import { Checkbox, Divider, Grid, Tooltip } from '@mui/material'
import { MouseEvent, useContext, useState } from 'react'
import IconsColor from './iconsColor';
import globalStyles from "../../assets/styles/global.module.scss";
import styles from "../../assets/styles/componentStyles/accountInformationCard.module.scss";
import GlobalButton from './globalButton/button';
import metaIcon from "../../assets/images/chatbot/metaIcon.png";
import { chatbotIntegrationAssignmentData, chatbotIntegrationAssignmentDataNew, zohoIntegrationOrganizationChatbotData } from '../../models/axiosModel';
import GlobalPopUp from './globalPopUp';
import QRimage from '../../assets/chatbotAssets/QRimage.png';
import QrCodePopup from './qrCodePopup';
import { ChatbotContext, ChatbotContextPayload } from '../../context/chatbotContext';
import { primaryColor, tertiaryColor, whiteColor } from '../../utils/colors';
import { getIntegrationIcon, hasChannelsManageAccess, getChannelQrText } from '../../utils/constants';
import { UserContext, UserContextPayload } from '../../context/userContext';
import InstagramConfiguration from '../dashboard/chatbot/instagramIntegration/instagramConfiguration';

type LinkedChatbot = chatbotIntegrationAssignmentDataNew | chatbotIntegrationAssignmentData | zohoIntegrationOrganizationChatbotData

interface Details {
    page_id?: string,
    integrated_channel_id: string,
    chatbot_name?: string
    chatbot_id?: string | number
    page_name?: string
    page_category?: string,
    linked_chatbots?: LinkedChatbot[],
    linked_workflows?: LinkedChatbot[],
}

interface FacebookInformationCardProps {
    title: string
    details: Details
    currentlySelected: boolean
    flagDelete: boolean
    flagShowMetaIcon?: boolean
    deleteChatbotIntegration?: () => void;
    removeChatbotIntegration?: (page_id: string, integrated_channel_id: string) => void
    addChatbotIntegration?: (page_id: string, event?: MouseEvent<HTMLButtonElement>) => void,
    showRemoveChatbotIntegration?: boolean,
    flagIntegration?: boolean,
    flagShowLinkedChatbot?: boolean,
    disabled?: boolean,
    integrationType: string,
    flagChatbotDeploy?: boolean,
}

export default function FacebookInformationCard(props: FacebookInformationCardProps) {

    const { title, details, currentlySelected, flagDelete, flagShowMetaIcon, showRemoveChatbotIntegration } = props;
    const { chatbotList } = useContext(ChatbotContext) as ChatbotContextPayload
    const { apiRoutesPermissionAssignment, userDetail } = useContext(UserContext) as UserContextPayload
    const [showInstagramSettingsPopup, setShowInstagramSettingsPopup] = useState<boolean>(false)
    const [showQRCodePopUp, setShowQRCodePopUp] = useState<boolean>(false)

    const qrValue = details.page_name?.trim() ?? ""
    const shouldShowQrCode = Boolean(qrValue) && Boolean(getChannelQrText(qrValue, props.integrationType))

    const shouldShowInstagramSettingsIcon = (
        (props.integrationType === "Instagram" && showRemoveChatbotIntegration && props.flagIntegration) 
        || (props.flagChatbotDeploy && details.linked_chatbots && details.linked_chatbots.length > 0)
    )

    return (
        <>
            <Grid item className={styles.mainGrid} style={{
                opacity: props.disabled ? "0.5" : "1"
            }}>
                <Grid container className={globalStyles.flexColumn}>
                    {flagShowMetaIcon &&
                        <Grid item sx={{ background: currentlySelected ? tertiaryColor : "#FFFFFF" }} className={styles.header} xs={12}>
                            <Grid container className={globalStyles.spaceAlignmentCenter}>

                                <Grid item className={globalStyles.displayFlex}>
                                    <Grid container>
                                        <Grid className={globalStyles.displayFlex} item>
                                            <img
                                                alt="meta"
                                                className={styles.metaIconStyle}
                                                src={metaIcon}
                                            />
                                        </Grid>
                                        <Grid item className={styles.headerText}>{title}</Grid>
                                    </Grid>
                                </Grid>

                                <Grid item>
                                    {flagDelete ?
                                        hasChannelsManageAccess(apiRoutesPermissionAssignment, userDetail) && 
                                            <GlobalButton buttonText={"Delete"} className="deleteIntegrationButton" onClick={props.deleteChatbotIntegration} startIcon={<IconsColor iconName="DeleteIcon" fillColor={primaryColor} height="16" width="16" />} />
                                        :
                                        <>
                                            <Grid container gap="10px">
                                                <Checkbox
                                                    checked={currentlySelected}
                                                    className={`${globalStyles.checkboxStyle} ${globalStyles.clickable}`}
                                                    checkedIcon={<IconsColor iconName="checkedIcon" width="22px" height="22px" />}
                                                    icon={<IconsColor iconName="uncheckedIcon" width="22px" height="22px" />}
                                                    onChange={() => {
                                                        if (props.addChatbotIntegration && details.page_id && !currentlySelected) {
                                                            props.addChatbotIntegration(details.page_id)
                                                        }
                                                    }}
                                                />
                                                {showRemoveChatbotIntegration && currentlySelected && props.removeChatbotIntegration &&
                                                    <GlobalButton buttonText={"Remove"} className='boxShadowButtonStyle' onClick={() => {
                                                        if (props.removeChatbotIntegration && details.page_id) {
                                                            props.removeChatbotIntegration(details.page_id, details.integrated_channel_id)
                                                        }
                                                    }} />
                                                }
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>}
                    {flagShowMetaIcon && <Divider style={{ opacity: "0.8" }} />}

                    {!flagShowMetaIcon &&
                        <Grid item>
                            <Grid container
                                gap={3}
                            >
                                <Grid item>
                                    <Grid container className={`${styles.facebookIntegrationCard} ${globalStyles.flexColumn}`}>
                                        
                                        {/* Page ID - Header */}
                                        <Grid item className={`${styles.facebookIntegrationCardHeader} ${props.integrationType === "Instagram" ? styles.instagramPageID : props.integrationType === "Slack" ? styles.slackPage : props.integrationType === "Zoho" ? styles.zohoPage : styles.integrationPageID}`}>
                                            <span className={props.integrationType === "Instagram" ? styles.instagramIDStyle : props.integrationType === "Slack" ? styles.slackIDStyle : props.integrationType === "Zoho" ? styles.slackIDStyle : styles.pageIDStyle}>
                                                ID: {props.details.page_id}
                                            </span>

                                            {shouldShowInstagramSettingsIcon &&
                                                <span 
                                                    className={`${globalStyles.displayFlex} ${styles.facebookIntegrationCardHeaderSettingsIcon}`}
                                                    onClick={() => { setShowInstagramSettingsPopup(true) }}
                                                >
                                                    <IconsColor 
                                                        iconName="integrationSettings"
                                                        fillColor={whiteColor}
                                                    />
                                                </span>
                                            }
                                        </Grid>

                                        {/* Integration Icon and Connection Status */}
                                        <Grid item>
                                            <Grid container className={globalStyles.contentEnd}>
                                                <Grid item className={props.integrationType === "Instagram" ? styles.instagramIcon : props.integrationType == "Slack" ? styles.slackIcon : styles.integrationIcon}>
                                                    {getIntegrationIcon(props.integrationType, "32")}
                                                </Grid>

                                                <Grid item className={styles.connectionStyle} sx={{ color: props.details.linked_chatbots && props.details.linked_chatbots.length > 0 ? "#32BB46" : "#BB3232" }}>
                                                    <span className={styles.connectionTextStyle}>{props.details.linked_chatbots && props.details.linked_chatbots.length > 0 ? "Connected" : "Not Connected"}</span>
                                                </Grid>

                                            </Grid>
                                        </Grid>

                                        {/* Page Name and QR Code */}
                                        <Grid item className={styles.integrationPageName}>
                                            {shouldShowQrCode ?
                                                <Grid container className={`${globalStyles.spaceAlignmentCenter} ${globalStyles.flexRow} ${globalStyles.gapOne}`}>
                                                    <Grid item>
                                                        <span className={styles.pageNameStyle}>{props.details.page_name}</span>
                                                    </Grid>
                                                    <Grid item>
                                                        <img
                                                            alt=""
                                                            src={QRimage}
                                                            height={"26"}
                                                            width={"26"}
                                                            className={props.disabled ? undefined : globalStyles.clickable}
                                                            onClick={props.disabled ? undefined : () => setShowQRCodePopUp(true)}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                :
                                                <span className={styles.pageNameStyle}>{props.details.page_name}</span>
                                            }
                                        </Grid>

                                        {/* Slack Description or Zoho User Name or Page Category */}
                                        <Grid item className={`${styles.integrationPageCategory} ${globalStyles.maxWidthFull}`} >
                                            <Grid container className={globalStyles.flexColumn}>
                                                <Grid item className={styles.pageCategoryStyle}>
                                                    <span>{props.integrationType == "Slack" ? "Slack Description" : props.integrationType == "Zoho" ? "Zoho User Name" : "Page Category"}</span>
                                                </Grid>
                                                {props.integrationType == "Slack" ?
                                                    <Tooltip title={props.details.page_category} arrow placement="right" className={styles.pageCategoryTooltip} >
                                                        <Grid item className={`${styles.pageCategoryTextStyle} ${styles.slackDescriptionTextStyle}`}>
                                                            <span>{props.details.page_category ? props.details.page_category : "-"}</span>
                                                        </Grid>
                                                    </Tooltip>
                                                    :
                                                    <Grid item className={`${styles.pageCategoryTextStyle} ${styles.slackDescriptionTextStyle}`}>
                                                        <span>{props.integrationType == "Zoho" ? props.details.page_name : props.details.page_category ? props.details.page_category : "-"}</span>
                                                    </Grid>
                                                }
                                            </Grid>
                                        </Grid>

                                        {/* Zoho User Email */}
                                        {props.integrationType == "Zoho" &&
                                            <Grid item className={`${styles.integrationPageCategory} ${globalStyles.maxWidthFull}`}>
                                                <Grid container direction={"column"}>
                                                    <Grid item className={styles.pageCategoryStyle}>
                                                        <span>Zoho User Email</span>
                                                    </Grid>
                                                    <Grid item className={`${styles.pageCategoryTextStyle} ${styles.slackDescriptionTextStyle}`}>
                                                        <span>{props.details.page_category ? props.details.page_category : "-"}</span>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }

                                        {/* Linked Rule-Based Chatbot */}
                                        {details.linked_workflows &&
                                            <Grid item className={styles.integrationPageCategory}>
                                                <Grid container className={`${globalStyles.flexRow} ${globalStyles.gapOne}`} justifyContent="space-between">
                                                    <Grid item>
                                                        <Grid container className={globalStyles.flexColumn}>
                                                            <Grid item className={styles.pageCategoryStyle}>
                                                                <span>Linked Rule-Based Chatbot</span>
                                                            </Grid>
                                                            <Grid item className={styles.chatbotNameStyle}>
                                                                {details.linked_workflows.length > 0 ? details.linked_workflows.map((chatbot, ind) => {
                                                                    const workflowName = chatbot.chatbot_name
                                                                    const showAsText = Boolean(props.flagIntegration && props.disabled)
                                                                    return (
                                                                        <span key={chatbot.chatbot_id ?? ind}>
                                                                            {showAsText ?
                                                                                <span className={styles.chatbotNameLink}>{workflowName}</span>
                                                                                :
                                                                                <a rel="noreferrer" className={styles.chatbotNameLink} href={`${window.location.origin}/workflow/staticWorkflowDetails?workflow_id=${chatbot.chatbot_id}`} target="_blank">{workflowName}</a>
                                                                            }
                                                                            {ind < (details.linked_workflows?.length || 0) - 1 && ", "}
                                                                        </span>
                                                                    )
                                                                }) : <span className={globalStyles.secondaryFontWeight}>None</span>}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }

                                        {/* Linked Chatbot */}
                                        {!props.flagShowLinkedChatbot && <Grid item className={styles.integrationPageCategory}>
                                            <Grid container className={`${globalStyles.gapOne} ${globalStyles.spaceAlignmentCenter}`}  >
                                                <Grid item>
                                                    <Grid container className={globalStyles.flexColumn}>
                                                        <Grid item className={styles.pageCategoryStyle}>
                                                            <span>Linked Chatbot</span>
                                                        </Grid>
                                                        <Grid item className={styles.chatbotNameStyle}>
                                                            {!props.flagIntegration &&
                                                                <Grid item className={styles.chatbotNameStyle}>
                                                                    {details.linked_chatbots && details.linked_chatbots.length > 0 ? details.linked_chatbots.map((chatbot: any, ind) => {
                                                                        return <a key={ind} rel="noreferrer" className={styles.chatbotNameLink} href={`${window.location.origin}/chatbot/viewChatbot?chatbot_id=${chatbot?.chatbot_id ?? chatbot?.ai_chatbot_id}`} target="_blank">{chatbot?.chatbot_name}</a>
                                                                    }) : <span>-</span>}
                                                                </Grid>
                                                            }
                                                            {props.flagIntegration &&
                                                                <Grid item className={styles.chatbotNameStyle}>
                                                                    {details.linked_chatbots && details.linked_chatbots.length > 0 ? details.linked_chatbots.map((chatbot: any, ind) => {
                                                                        return <a key={ind} rel="noreferrer" className={styles.chatbotNameLink} href={`${window.location.origin}/chatbot/viewChatbot?chatbot_id=${chatbot?.chatbot_id ?? chatbot?.ai_chatbot_id}`} target="_blank">{chatbotList?.find((list) => Number(list.chatbot_id) == (chatbot?.chatbot_id ?? chatbot?.ai_chatbot_id))?.chatbot_name}</a>
                                                                    }) : <span>-</span>}
                                                                </Grid>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                {showRemoveChatbotIntegration && props.flagIntegration &&
                                                    currentlySelected && props.removeChatbotIntegration &&
                                                    <Grid item>
                                                        <GlobalButton buttonText={"Un-deploy"} className='delinkChatbotButtonStyle' onClick={() => {
                                                            if (props.removeChatbotIntegration && details.page_id) {
                                                                props.removeChatbotIntegration(details.page_id, details.integrated_channel_id)
                                                            }
                                                        }} />
                                                    </Grid>
                                                }
                                                {props.flagIntegration && !showRemoveChatbotIntegration && props.removeChatbotIntegration && props.addChatbotIntegration &&
                                                    <Grid item>
                                                        <GlobalButton buttonText={"Deploy"} className='linkChatbotButtonStyle' onClick={() => {
                                                            if (props.addChatbotIntegration && details.page_id && !currentlySelected) {
                                                                props.addChatbotIntegration(details.page_id)
                                                            }
                                                        }} disabled={currentlySelected} />
                                                    </Grid>
                                                }
                                                {props.flagChatbotDeploy &&
                                                    ((details.linked_chatbots && details.linked_chatbots.length > 0) ?
                                                        <Grid item>
                                                            <GlobalButton buttonText={"De-Link"} className='delinkChatbotButtonStyle' onClick={() => {
                                                                if (props.removeChatbotIntegration && details.page_id) {
                                                                    props.removeChatbotIntegration(details.page_id, details.integrated_channel_id)
                                                                }
                                                            }} />
                                                        </Grid>
                                                        :
                                                        <Grid item>
                                                            <GlobalButton buttonText={"Link"} className='linkChatbotButtonStyle' onClick={() => {
                                                                if (props.addChatbotIntegration && details.page_id) {
                                                                    props.addChatbotIntegration(details.page_id)
                                                                }
                                                            }} />
                                                        </Grid>)
                                                }
                                            </Grid>
                                        </Grid>}
                                        
                                        {props.flagShowLinkedChatbot &&
                                            <Grid item className={styles.integrationPageCategory}>
                                                <Grid container className={`${globalStyles.flexRow} ${globalStyles.gapOne}`} justifyContent="space-between">
                                                    <Grid item>
                                                        <Grid container className={globalStyles.flexColumn}>
                                                            <Grid item className={styles.pageCategoryStyle}>
                                                                <span>Linked Chatbot</span>
                                                            </Grid>
                                                            {!props.flagIntegration &&
                                                                <Grid item className={styles.chatbotNameStyle}>
                                                                    {details.linked_chatbots && details.linked_chatbots.length > 0 ? details.linked_chatbots.map((chatbot: any, ind) => {
                                                                        return <a key={ind} rel="noreferrer" className={styles.chatbotNameLink} href={`${window.location.origin}/chatbot/viewChatbot?chatbot_id=${chatbot?.chatbot_id ?? chatbot?.ai_chatbot_id}`} target="_blank">{chatbot?.chatbot_name}</a>
                                                                    }) : <span className={globalStyles.secondaryFontWeight}>None</span>}
                                                                </Grid>
                                                            }
                                                            {props.flagIntegration &&
                                                                <Grid item className={styles.chatbotNameStyle}>
                                                                    {details.linked_chatbots && details.linked_chatbots.length > 0 ? details.linked_chatbots.map((chatbot: any, ind) => {
                                                                        return props.disabled ? <span key={ind} className={styles.chatbotNameLink}>{chatbotList?.find((list) => Number(list.chatbot_id) == (chatbot?.chatbot_id ?? chatbot?.ai_chatbot_id))?.chatbot_name}</span> : <a key={ind} rel="noreferrer" className={styles.chatbotNameLink} href={`${window.location.origin}/chatbot/viewChatbot?chatbot_id=${chatbot?.chatbot_id ?? chatbot?.ai_chatbot_id}`} target="_blank">{chatbotList?.find((list) => Number(list.chatbot_id) == (chatbot?.chatbot_id ?? chatbot?.ai_chatbot_id))?.chatbot_name}</a>
                                                                    }) : <span className={globalStyles.secondaryFontWeight}>None</span>}
                                                                </Grid>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    {showRemoveChatbotIntegration && props.flagIntegration &&
                                                        currentlySelected && props.removeChatbotIntegration &&
                                                        <Grid item>
                                                            <GlobalButton buttonText={"Un-deploy"} className='delinkChatbotButtonStyle' onClick={() => {
                                                                if (props.removeChatbotIntegration && details.page_id) {
                                                                    props.removeChatbotIntegration(details.page_id, details.integrated_channel_id)
                                                                }
                                                            }} />
                                                        </Grid>
                                                    }
                                                    {!showRemoveChatbotIntegration && props.flagIntegration && props.removeChatbotIntegration && props.addChatbotIntegration &&
                                                        <Grid item>
                                                            <GlobalButton buttonText={props.integrationType == "Zoho" ? "Integrate" : "Deploy"} className='linkChatbotButtonStyle' onClick={(event) => {
                                                                if (props.addChatbotIntegration && details.page_id && !currentlySelected) {
                                                                    props.addChatbotIntegration(details.page_id, event)
                                                                }
                                                            }} disabled={currentlySelected} />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </Grid>
                                        }

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Grid>

            {/* QR Code Popup */}
            {showQRCodePopUp && shouldShowQrCode &&
                <GlobalPopUp
                    open={showQRCodePopUp}
                    onClose={() => { setShowQRCodePopUp(false) }}
                    flagShowCloseIcon={true}
                    handleClose={() => { setShowQRCodePopUp(false) }}
                    borderRadius='10px'
                    titlePadding='0px'
                    overflow="hidden"
                >
                    <QrCodePopup
                        phoneNumberQR={qrValue}
                        channelName={props.integrationType}
                    />
                </GlobalPopUp>
            }

            {/* Instagram Settings Popup */}
            {showInstagramSettingsPopup &&
                <InstagramConfiguration 
                    open={showInstagramSettingsPopup} 
                    handleClose={() => setShowInstagramSettingsPopup(false)} 
                    pageID={props.details.page_id ?? ""} 
                    page={props.details.page_name ?? ""}
                    channelDeploymentID={(props.details.linked_chatbots?.[0] as chatbotIntegrationAssignmentDataNew)?.chatbot_integrated_channel_deployment_id ?? ""}
                />
            }
        </>
    )
}
